import { jottacloudtheme } from '@jotta/ui/themes/jottacloud'
import { startApp } from '../App'
import { env } from '@jotta/utils/env'

function dl() {
  return window.dataLayer || (window.dataLayer = [])
}
function mtm() {
  return window._mtm || (window._mtm = [])
}
let trackingError: any
try {
  dl()
  window.gtag = function (...rest: any[]) {
    dl().push(...rest)
  }

  if (!/mobile_app=true/i.test(window.location.search)) {
    window._paq = window._paq || []

    mtm().push({ 'mtm.startTime': new Date().getTime(), event: 'mtm.Start' })
    // TODO less secure than nonce in dynamic html script tag since we nonce is not hidden albeit a bit obscure
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Global_attributes/nonce#accessing_nonces_and_nonce_hiding
    const nonce = performance.getEntries().flatMap((performanceEntry: any) => {
      return performanceEntry.serverTiming?.flatMap((serverTiming: any) => {
        const description = serverTiming.description
        return description && serverTiming.name === 'csp-nonce'
          ? [description]
          : []
      })
    })[0]

    const matomoElement = document.createElement('script')
    matomoElement.async = true
    matomoElement.setAttribute('nonce', nonce) // https://matomo.org/faq/general/faq_20904/
    matomoElement.src = 'https://a.jottacloud.com/js/container_FDVOG8VX.js'

    const firstScriptElement = document.getElementsByTagName('script')[0]
    firstScriptElement.parentNode!.insertBefore(
      matomoElement,
      firstScriptElement,
    )

    if (!nonce && !env.isLocal) {
      throw new Error('csp nonce not found')
    }
  }
} catch (e) {
  trackingError = e
}

startApp(jottacloudtheme)

if (trackingError) {
  throw trackingError
}
